"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Result, {
    title: "Demo\u793A\u610F",
    subTitle: "\u80CC\u666F\u8272\u4E3A colorFillAlter"
  }, "Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait.");
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorFillAlter'],
  key: 'resultWithDesc'
};
var _default = exports.default = componentDemo;